import { render } from "./LabdaqInvalidOrders.vue?vue&type=template&id=6fa51dff"
import script from "./LabdaqInvalidOrders.vue?vue&type=script&lang=js"
export * from "./LabdaqInvalidOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/LabdaqInvalidOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fa51dff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fa51dff', __exports__)) {
    console.log('reload')
    api.reload('6fa51dff', __exports__)
  }
  
  module.hot.accept("./LabdaqInvalidOrders.vue?vue&type=template&id=6fa51dff", () => {
    console.log('re-render')
    api.rerender('6fa51dff', render)
  })

}


export default __exports__